<template>
  <parts @remove="$emit('remove')" title="フェードイン">
    <td>
    </td>
  </parts>
</template>

<script>
import parts from './parts'
export default {
  name: 'fade-in',
  props:{
    options: Object
  },
  components:{
    parts
  },
  data () {
    return {
      form: {
      },
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
</style>
